import React from "react";
import "./footer.css";
import { PiLinkSimpleBold } from "react-icons/pi";
import { IoPricetags } from "react-icons/io5";
import { FaRegClock, FaRegAddressBook } from "react-icons/fa6";
import { Link } from "react-router-dom";
// import { FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="social-icons">
          <a href="https://www.instagram.com/mandurahcafe" target="_blank" rel="noreferrer">
            <img src="/Images/insta.png" alt="Instagram" loading="lazy"/>
          </a>
          {/* <a href="https://twitter.com" target="_blank" rel="noreferrer">
            <img src="/Images/x.png" alt="Twitter" />
          </a> */}
          <a href="https://www.facebook.com/mandurahcafe" target="_blank" rel="noreferrer">
            <img src="/Images/facebook.png" alt="Facebook" loading="lazy" />
          </a>
          {/* <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <img src="/Images/linkdin.png" alt="LinkedIn" />
          </a>
          <a href="https://pinterest.com" target="_blank" rel="noreferrer">
            <img src="/Images/pinarts.png" alt="Pinterest" />
          </a> */}
        </div>

        <div className="footer-logo">
          <img src="/Images/footer-logo1.png" alt="Mandurah Cafe" loading="lazy"/>
          {/* <h2>FARBOY CAFE</h2> */}
        </div>

        <div className="footer-contact">
          <div className="icon">
            <img src="/Images/phone-call.svg" alt="Call" loading="lazy"/>
          </div>
          <div className="numbers">
            <a href="tel:+61452246919">+61 452 246 919</a>
            <a href="tel:+61482603476">+61 482 603 476</a>
          </div>
        </div>
      </div>
      <div className="footer-middle-main">
        <div className="footer-middle">
          <div className="footer-column">
            <h4>
              <FaRegAddressBook style={{ marginRight: "8px" }} />
              ADDRESS
            </h4>
            <ul>
              <li>31 Sholl St, Mandurah WA 6210</li>
              <li>
                <a href="tel:+61452246919">+61 452 246 919</a>
              </li>
              <li>
                <a href="tel:+61482603476">+61 482 603 476</a>
              </li>

              <li style={{ marginTop: "12px" }}>
                We’re located at
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                  className="footer-google-details"
                >
                  {/* Left: Location Icon */}
                  <a
                    href="https://g.co/kgs/xK6LRUw"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      background: "#f1f1f1",
                      borderRadius: "8px",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "40px",
                      height: "40px",
                    }}
                  >
                    <img
                      src="./Images/square.svg" // your location icon
                      alt="Location"
                      style={{ height: "50px", width: "50px" }}
                      loading="lazy"
                    />
                  </a>

                  {/* Right: Google Review Button */}
                  <a
                    href="https://g.page/r/CSx91QLVviigEBM/review"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // backgroundColor: '#4285f4',
                      padding: "8px 12px",
                      borderRadius: "6px",
                      color: "#fff",
                      textDecoration: "none",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    <img
                      src="./Images/google-review-logo.png"
                      alt="Google"
                      style={{ height: "50px", marginRight: "8px" }}
                      loading="lazy"
                    />
                  </a>
                </div>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>
              <PiLinkSimpleBold /> QUICK LINKS
            </h4>
            <ul>
              <li>
                <Link to="/about-mandurah-cafe">About Us</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
              {/* <li>
                <Link to="/gallery">Gallery</Link>
              </li> */}
              <li>
                <Link to="/view-our-menu">View Our Menu</Link>
              </li>
              {/* <li>
                <Link to="/cart">Cart</Link>
              </li> */}
              <li>
                <Link to="/teams-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                {" "}
                <Link to="/mandurah-cafe-offers">Offers In Mandurah</Link>
              </li>
              <li>
                {" "}
                <Link to="/informative-blog">Informative Blog</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>
              <IoPricetags /> CATEGORY
            </h4>
            <ul>
              <li>
                {" "}
                <Link to="/aussie-breakfast-in-mandurah">Aussie Breakfast</Link>
              </li>
              <li>
                {" "}
                <Link to="/indian-street-food-in-mandurah">Indian Street Food</Link>
              </li>
              <li>
                {" "}
                <Link to="/indo-chinese-in-mandurah">Indo Chinese</Link>
              </li>
              <li>
                {" "}
                <Link to="/indian-cuisine-in-mandurah">Indian Cuisine</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>
              {" "}
              <FaRegClock /> OPENING HOURS
            </h4>
            <ul>
              <li>
                <span className="timing-red">Monday: 6:00 AM – 5:00 PM</span>
              </li>
              <li>
                <span className="timing-red">Tuesday: 6:00 AM – 5:00 PM</span>
              </li>
              <li>
                <span className="timing-red">Wednesday: 6:00 AM – 8:00 PM</span>
              </li>
              <li>
                <span className="timing-red">Thursday: 6:00 AM – 8:00 PM</span>
              </li>
              <li>
                <span className="timing-red">Friday: 6:00 AM – 8:00 PM</span>
              </li>
              <li>
                <span className="timing-red">Saturday: 6:00 AM – 8:00 PM</span>
              </li>
              <li>
                <span className="timing-red">Sunday: 8:00 AM – 12:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          Copyright © 2025 MANDURAH CAFE |{" "}
          <a href="https://hjsysweb.com">
            {" "}
            Designed and Developed by{" "}
            <img src="/Images/icon-hj.svg" alt="Hj Sysweb" loading="lazy" />{" "}
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
